// extracted by mini-css-extract-plugin
export default {"tooltip":"ET-z","arrow":"FT-z"};